import { render, staticRenderFns } from "./FeedbackQuestionShow.vue?vue&type=template&id=5003402a&scoped=true&"
import script from "./FeedbackQuestionShow.vue?vue&type=script&lang=ts&"
export * from "./FeedbackQuestionShow.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackQuestionShow.vue?vue&type=style&index=0&id=5003402a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003402a",
  null
  
)

export default component.exports